module.exports = __webpack_public_path__ + "img/구름많고눈비.647fa66c.png";